import {
  SkeletonContainer as CXSkeletonContainer,
  SkeletonText as CXSkeletonText
} from '@sanlamcx/react-ui-next-skeleton';

export const SkeletonContainer = CXSkeletonContainer;
export const SkeletonText = CXSkeletonText;
